import { compose } from 'ramda';
import { withApollo } from 'react-apollo';
import AccountComponent from './AccountComponent';

export default compose(withApollo)(AccountComponent);
